// @flow

import type { Action } from './store.type';

export const GET_DASHBOARD_BLOCKS_REQUEST = 'GET_DASHBOARD_BLOCKS_REQUEST';
type GET_DASHBOARD_BLOCKS_REQUEST_TYPE = 'GET_DASHBOARD_BLOCKS_REQUEST';

export const GET_DASHBOARD_BLOCKS_SUCCESS = 'GET_DASHBOARD_BLOCKS_SUCCESS';
type GET_DASHBOARD_BLOCKS_SUCCESS_TYPE = 'GET_DASHBOARD_BLOCKS_SUCCESS';

export const GET_DASHBOARD_BLOCKS_FAILURE = 'GET_DASHBOARD_BLOCKS_FAILURE';
type GET_DASHBOARD_BLOCKS_FAILURE_TYPE = 'GET_DASHBOARD_BLOCKS_FAILURE';

export const GET_DASHBOARD_COMPONENTS_REQUEST = 'GET_DASHBOARD_COMPONENTS_REQUEST';
type GET_DASHBOARD_COMPONENTS_REQUEST_TYPE = 'GET_DASHBOARD_COMPONENTS_REQUEST';

export const GET_DASHBOARD_COMPONENTS_SUCCESS = 'GET_DASHBOARD_COMPONENTS_SUCCESS';
type GET_DASHBOARD_COMPONENTS_SUCCESS_TYPE = 'GET_DASHBOARD_COMPONENTS_SUCCESS';

export const GET_DASHBOARD_COMPONENTS_FAILURE = 'GET_DASHBOARD_COMPONENTS_FAILURE';
type GET_DASHBOARD_COMPONENTS_FAILURE_TYPE = 'GET_DASHBOARD_COMPONENTS_FAILURE';

export const FEEDBACK_REQUEST = 'FEEDBACK_REQUEST';
type FEEDBACK_REQUEST_TYPE = 'FEEDBACK_REQUEST';

export const FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS';
type FEEDBACK_SUCCESS_TYPE = 'FEEDBACK_SUCCESS';

export const FEEDBACK_FAILURE = 'FEEDBACK_FAILURE';
type FEEDBACK_FAILURE_TYPE = 'FEEDBACK_FAILURE';

export const PROCESS_DISMISS_BLOCK_REQUEST = 'PROCESS_DISMISS_BLOCK_REQUEST';
type PROCESS_DISMISS_BLOCK_REQUEST_TYPE = 'PROCESS_DISMISS_BLOCK_REQUEST';

export const PROCESS_DISMISS_BLOCK_SUCCESS = 'PROCESS_DISMISS_BLOCK_SUCCESS';
type PROCESS_DISMISS_BLOCK_SUCCESS_TYPE = 'PROCESS_DISMISS_BLOCK_SUCCESS';

export const PROCESS_DISMISS_BLOCK_FAILURE = 'PROCESS_DISMISS_BLOCK_FAILURE';
type PROCESS_DISMISS_BLOCK_FAILURE_TYPE = 'PROCESS_DISMISS_BLOCK_FAILURE';

export const UNDO_DISMISS_BLOCK_REQUEST = 'UNDO_DISMISS_BLOCK_REQUEST';
type UNDO_DISMISS_BLOCK_REQUEST_TYPE = 'UNDO_DISMISS_BLOCK_REQUEST';

export const UNDO_DISMISS_BLOCK_SUCCESS = 'UNDO_DISMISS_BLOCK_SUCCESS';
type UNDO_DISMISS_BLOCK_SUCCESS_TYPE = 'UNDO_DISMISS_BLOCK_SUCCESS';

export const UNDO_DISMISS_BLOCK_FAILURE = 'UNDO_DISMISS_BLOCK_FAILURE';
type UNDO_DISMISS_BLOCK_FAILURE_TYPE = 'UNDO_DISMISS_BLOCK_FAILURE';

export const CONFIRM_DISMISS_BLOCK = 'CONFIRM_DISMISS_BLOCK';
type CONFIRM_DISMISS_BLOCK_TYPE = 'CONFIRM_DISMISS_BLOCK';

export const UPDATE_DASHBOARD_BLOCK = 'UPDATE_DASHBOARD_BLOCK';
type UPDATE_DASHBOARD_BLOCK_TYPE = 'UPDATE_DASHBOARD_BLOCK';

type GetDashboardBlocksSuccess = {
  data: Object
};

type GetDashboardComponentsSuccess = {
  data: Object
};

type DashBoardFaiure = {
  error: any
};

type DashBoardBlockFailure = DashBoardFaiure & {
  blockName: string
};

type DismissBlockSuccess = {
  data: Object,
  blockName: string
};

type GetDashboardBlocksRequestAction = Action<GET_DASHBOARD_BLOCKS_REQUEST_TYPE, null>;

type GetDashboardBlocksSuccessAction = Action<
  GET_DASHBOARD_BLOCKS_SUCCESS_TYPE,
  GetDashboardBlocksSuccess
>;

type GetDashboardBlocksFailureAction = Action<GET_DASHBOARD_BLOCKS_FAILURE_TYPE, DashBoardFaiure>;

type GetDashboardComponentsRequestAction = Action<GET_DASHBOARD_COMPONENTS_REQUEST_TYPE, null>;

type GetDashboardComponentsSuccessAction = Action<
  GET_DASHBOARD_COMPONENTS_SUCCESS_TYPE,
  GetDashboardComponentsSuccess
>;

type GetDashboardComponentsFailureAction = Action<
  GET_DASHBOARD_COMPONENTS_FAILURE_TYPE,
  DashBoardFaiure
>;

type FeedBackRequestAction = Action<FEEDBACK_REQUEST_TYPE, { blockName: string }>;

type FeedBackSuccessAction = Action<FEEDBACK_SUCCESS_TYPE, { message: string, blockName: string }>;

type FeedBackFailureAction = Action<FEEDBACK_FAILURE_TYPE, DashBoardBlockFailure>;

type ProcessDismissBlockRequestAction = Action<
  PROCESS_DISMISS_BLOCK_REQUEST_TYPE,
  { blockName: string }
>;

type ProcessDismissBlockSuccessAction = Action<
  PROCESS_DISMISS_BLOCK_SUCCESS_TYPE,
  DismissBlockSuccess
>;

type ProcessDismissBlockFailureAction = Action<
  PROCESS_DISMISS_BLOCK_FAILURE_TYPE,
  DashBoardBlockFailure
>;

type UndoDismissBlockRequestAction = Action<UNDO_DISMISS_BLOCK_REQUEST_TYPE, { blockName: string }>;

type UndoDismissBlockSuccessAction = Action<UNDO_DISMISS_BLOCK_SUCCESS_TYPE, DismissBlockSuccess>;

type UndoDismissBlockFailureAction = Action<UNDO_DISMISS_BLOCK_FAILURE_TYPE, DashBoardBlockFailure>;

type ConfirmDismissBlockAction = Action<CONFIRM_DISMISS_BLOCK_TYPE, { blockName: string }>;

type UpdateDashboardBlockAction = Action<UPDATE_DASHBOARD_BLOCK_TYPE, { blocks: Object }>;

export type DashboardAction =
  | GetDashboardBlocksRequestAction
  | GetDashboardBlocksSuccessAction
  | GetDashboardBlocksFailureAction
  | GetDashboardComponentsRequestAction
  | GetDashboardComponentsSuccessAction
  | GetDashboardComponentsFailureAction
  | FeedBackRequestAction
  | FeedBackSuccessAction
  | FeedBackFailureAction
  | ProcessDismissBlockRequestAction
  | ProcessDismissBlockSuccessAction
  | ProcessDismissBlockFailureAction
  | UndoDismissBlockRequestAction
  | UndoDismissBlockSuccessAction
  | UndoDismissBlockFailureAction
  | ConfirmDismissBlockAction
  | UpdateDashboardBlockAction;

export type DashboardState = {
  loading: boolean,
  success: boolean,
  dashboardComponentsLoading: boolean,
  dashboardComponentsSuccess: boolean,
  feedbackLoading: Array<string>,
  feedbackSuccess: Array<string>,
  dismissLoading: Array<string>,
  dismissSuccess: Array<string>,
  error: any,
  dashboardBlocks: Object,
  dashboardComponents: Object
};
